import { render } from "./CareerDetails.vue?vue&type=template&id=6babb45f&scoped=true"
import script from "./CareerDetails.vue?vue&type=script&lang=js"
export * from "./CareerDetails.vue?vue&type=script&lang=js"

import "./CareerDetails.vue?vue&type=style&index=0&id=6babb45f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6babb45f"]])

export default __exports__